import { DataConverter } from "../../../Global/Base/Converters/DataConverter";
import { ArrayUtils } from "../../../Global/Base/Utils/ArrayUtils";
import { BigIntOps } from "./BigIntOps";

export class OWDecimal {
    private readonly _data: Uint8Array;
    private readonly _flag: number;

    // @ts-ignore // nevyužito, ale ponecháno
    private static _signFlag = 0x80000000;
    private static _scaleShift = 16;
    // @ts-ignore // nevyužito, ale ponecháno
    private static _reservedSs32Bits = 0x7F00FFFF;
    private static _scaleMask = 0xFF0000;

    constructor(data: Uint8Array, flag: number) {
        this._data = data;
        this._flag = flag;
    }

    // Decimal
    // AQAAAA8AAPAAAAAAAAABAA==
    // 1729382263352721408.1
    // Fc1bBwAAAAAAAAAAAAAGAA==
    // 123.456789
    // Fc1bBwAAAAAAAAAAAAAGgA==
    // -123.456789
    // eLRg47gPzExgr+kfAAAAAA==
    // 9876543210987654321098765432

    public static fromBase64(data64: string): OWDecimal {
        const data = DataConverter.base64ToArray(data64);
        const dw = new DataView(data.buffer);
        const flag = dw.getUint32(12, true);
        return new OWDecimal(data, flag);
    }

    // vraci cislo prevedene do typu Number
    // je nutne pocitat se ztratou presnosti
    public toNumber(): number {
        const dw = new DataView(this._data.buffer);
        const lo = dw.getUint32(0, true);
        const mi = dw.getUint32(4, true);
        const hi = dw.getUint32(8, true);
        const flag = dw.getUint32(12, true);
        const isNegative = flag >>> 31;
        const scale = (flag & OWDecimal._scaleMask) >>> OWDecimal._scaleShift;
        let r = (hi * 0x100000000 * 0x100000000 + mi * 0x100000000 + lo) / Math.pow(10, scale);
        if (isNegative)
            r *= -1;
        return r;
    }

    public toString(): string {
        const isNegative = this._flag >>> 31 === 1;
        const scale = (this._flag & OWDecimal._scaleMask) >>> OWDecimal._scaleShift;
        return BigIntOps.decimalToString(ArrayUtils.copyUint8Array(this._data, 0, 12), scale, isNegative);
    }
}
